import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAddressCard, faUsers } from '@fortawesome/free-solid-svg-icons'

const AssignedBadge = ({ rule }) => {
  const { assignable } = rule

  if (!assignable) {
    return <span className="badge badge-light">Unassigned</span>
  }

  if (rule.assignable_type === 'Role') {
    return (
      <span>
        {assignable.name} <FontAwesomeIcon icon={faAddressCard} />
      </span>
    )
  } else if (rule.assignable_type === 'Employee') {
    return (
      <span>
        {assignable.name} <FontAwesomeIcon icon={faUsers} />
      </span>
    )
  }
  return <span className="badge badge-light">Unknown</span>
}

export default AssignedBadge
